import { useBasketMonitor } from "@trader-dashboard/shared";
import { AlertTriangle } from "lucide-react";
import { BasketCard } from "./BasketCard";

export const BasketMonitorPanel = (): React.ReactNode => {
  const { baskets, account, detailError } = useBasketMonitor();

  const gateActive = account?.gateLevel === "warning" || account?.gateLevel === "critical";
  if (baskets.length === 0 && !gateActive) return null;

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-lg font-semibold">Basket Monitor</h2>

      {account && account.gateLevel !== "none" && (
        <div
          className={`flex items-center gap-2 rounded-md border p-3 text-sm font-medium ${
            account.gateLevel === "critical"
              ? "border-red-300 bg-red-50 text-red-800"
              : "border-amber-300 bg-amber-50 text-amber-800"
          }`}
        >
          <AlertTriangle className="h-4 w-4 shrink-0" />
          <span className="tabular-nums">
            Floating {account.gatePct.toFixed(1)}% of equity
            {account.gateLevel === "critical"
              ? " — critical: stop opening new baskets on flat pairs"
              : " — warning"}
          </span>
        </div>
      )}

      {detailError && (
        <p className="text-xs text-muted-foreground">
          Order detail unavailable ({detailError}) — showing live feed figures only.
        </p>
      )}

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {baskets.map((basket) => (
          <BasketCard key={basket.key} basket={basket} />
        ))}
      </div>
    </div>
  );
};
